/* esm.sh - rxjs@7.8.1/dist/esm/internal/observable/empty */
import{Observable as t}from"../Observable.mjs";var o=new t(e=>e.complete());function c(e){return e?r(e):o}function r(e){return new t(n=>e.schedule(()=>n.complete()))}export{o as EMPTY,c as empty};
//# sourceMappingURL=empty.mjs.map